import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'
import { ClosingCta } from '@/components/generals/closing-cta'
import { RevealObserver } from '@/components/generals/reveal-observer'

export const Layout: FC<LayoutProps> = ({ children, cta = true }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only rounded-full bg-burgundy px-5 py-3 text-sm font-medium text-cream focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70]'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            {cta && <ClosingCta />}

            <SiteFooter />

            <RevealObserver />
        </div>
    )
}
